import { useParams } from "react-router-dom";
import { useGetPronosticV2Query } from "pronosticsv2/api/pronosticv2.api";
import { Pronosticv2AdminForm } from "../components/forms/Pronosticv2AdminForm";
import QueryWrapper from "common/components/QueryWrapper";

export function Pronosticv2AdminView() {
  const { pronosticsv2Id } = useParams<{ pronosticsv2Id: string }>();

  const query = useGetPronosticV2Query(pronosticsv2Id!, {
    skip: !pronosticsv2Id,
  });

  return (
    <>
      {pronosticsv2Id ? (
        <QueryWrapper query={query}>
          {(pronostic) => (
            <Pronosticv2AdminForm pronostic={pronostic} editMode={true} />
          )}
        </QueryWrapper>
      ) : (
        <Pronosticv2AdminForm editMode={false} />
      )}
    </>
  );
}
